export const GET_DASHBOARDDATA = 'store/dashboardReducer/GET_DASHBOARDDATA'
export const SET_SORTPARAMS = 'store/dashboardReducer/SET_SORTPARAMS'



// WEBPACK FOOTER //
// ./src/actionTypes/Dashboard/Dashboard.js